import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { createRef } from 'react';
import { mergeClassNameToColumnHeader } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import FilterableFormatter from './filterableFormatter.js';
import './components/FilterableHeader.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'prop-types';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-utilities/hooks/useResizeObserver';
import '@elliemae/ds-system/theme';
import './components/filterable-menus/getFilterMenuByType.js';
import './components/filterable-menus/DateRangeFilterMenu.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-date-range-picker';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-icons/DatePicker2';
import '@elliemae/ds-basic/Button';
import 'moment';
import './components/filterable-menus/defaultDateFormat.js';
import './components/filterable-menus/SingleDateFilterMenu.js';
import './components/filterable-menus/SingleRangeSwitcherMenu.js';
import './components/filterable-menus/TextFilterMenu.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'lodash';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-menu';
import '@elliemae/ds-icons/SearchSmall';
import './helper.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var addFilterToColumn = function addFilterToColumn(props, column) {
  var filterMenuRef = /*#__PURE__*/createRef();
  column.header.formatters.push(FilterableFormatter(_objectSpread(_objectSpread({}, props), {}, {
    filterMenuRef: filterMenuRef
  })));
  column.filterMenu = filterMenuRef;
  return mergeClassNameToColumnHeader('with-filtering', column);
};

export { addFilterToColumn };
//# sourceMappingURL=addFilterToColumn.js.map
